"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_EDD_VARIABLES = void 0;
const client_1 = require("@apollo/client");
exports.GET_EDD_VARIABLES = (0, client_1.gql) `
  query estimatedDeliveryDateVariables($accountId: ID!) {
    estimatedDeliveryDateVariables(accountId: $accountId) {
      __typename
      id
      description
      name
      reserved
      type
      ... on DateRangeVariable {
        maxDays
        minDays
      }
      ... on DateVariable {
        minDays
      }
    }
  }
`;
